// "use client";
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Tabs,
//   Tab,
//   Checkbox,
//   FormControlLabel,
//   Typography,
// } from "@mui/material";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { getalllocations, getalloutlettype } from "../../../pages/assign-task/api";

// // ⭐ Define last login keys
// type LastLoginKeys =
//   | "Today"
//   | "Last2Days"
//   | "Last3Days"
//   | "Last1Week"
//   | "MoreThan15Days";

// const tabsConfig = [
//   { key: "locations", label: "Location" },
//   { key: "outlettype", label: "Outlet Type" },
//   { key: "lastlogin", label: "Last Login" },
// ];

// function BulkUploadFilter() {
//   const [selectedTab, setSelectedTab] = useState(0);

//   // ⭐ API driven data
//   const [locations, setLocations] = useState<string[]>([]);
//   const [outletTypes, setOutletTypes] = useState<string[]>([]);

//   // ⭐ Last login filters state with strong typing
//   const [lastLoginFilters, setLastLoginFilters] = useState<
//     Record<LastLoginKeys, boolean>
//   >({
//     Today: false,
//     Last2Days: false,
//     Last3Days: false,
//     Last1Week: false,
//     MoreThan15Days: false,
//   });

//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
//     null,
//     null,
//   ]);

//   // ⭐ Fetch API data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [locRes, outletRes] = await Promise.all([
//           getalllocations(),
//           getalloutlettype(),
//         ]);

//         setLocations(locRes?.data?.data || []); // adjust if response shape differs
//         setOutletTypes(outletRes?.data?.data || []);
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
//     setSelectedTab(newValue);
//   };

//   // ⭐ Handle last login checkboxes + date ranges
//   const handleLastLoginClick = (key: LastLoginKeys) => {
//     setLastLoginFilters((prev) => {
//       const updated: Record<LastLoginKeys, boolean> = {
//         Today: false,
//         Last2Days: false,
//         Last3Days: false,
//         Last1Week: false,
//         MoreThan15Days: false,
//       };
//       updated[key] = !prev[key];

//       const today = new Date();
//       let newRange: [Date | null, Date | null] = [null, null];

//       switch (key) {
//         case "Today":
//           newRange = [today, today];
//           break;
//         case "Last2Days":
//           newRange = [
//             new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2),
//             today,
//           ];
//           break;
//         case "Last3Days":
//           newRange = [
//             new Date(today.getFullYear(), today.getMonth(), today.getDate() - 3),
//             today,
//           ];
//           break;
//         case "Last1Week":
//           newRange = [
//             new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7),
//             today,
//           ];
//           break;
//         case "MoreThan15Days":
//           newRange = [
//             null,
//             new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15),
//           ];
//           break;
//       }

//       setDateRange(newRange);
//       return updated;
//     });
//   };

//   return (
//     <Box
//       sx={{
//         position: "absolute",
//         width: "600px",
//         right: "3%",
//         backgroundColor: "#fff",
//         padding: "20px",
//         borderRadius: "10px",
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//         zIndex: 9999,
//       }}
//     >
//       <Box sx={{ width: "100%", display: "flex" }}>
//         {/* Tabs */}
//         <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
//           <Tabs
//             orientation="vertical"
//             value={selectedTab}
//             onChange={handleTabChange}
//           >
//             {tabsConfig.map((tab) => (
//               <Tab
//                 key={tab.key}
//                 label={tab.label}
//                 sx={{
//                   alignItems: "flex-start",
//                   justifyContent: "flex-start",
//                   textAlign: "left",
//                   pl: 2,
//                 }}
//               />
//             ))}
//           </Tabs>
//         </Box>

//         {/* Filters */}
//         <Box sx={{ paddingLeft: "20px", flexGrow: 1, display: "flex" }}>
//           {selectedTab === 0 && (
//             <Box sx={{ width: "200px" }}>
//               <FormControlLabel
//                 control={<Checkbox />}
//                 label="Select All"
//               />
//               {locations.map((loc) => (
//                 <FormControlLabel
//                   key={loc}
//                   control={<Checkbox />}
//                   label={loc}
//                   sx={{ display: "block" }}
//                 />
//               ))}
//             </Box>
//           )}

//           {selectedTab === 1 && (
//             <Box sx={{ width: "200px" }}>
//               <FormControlLabel
//                 control={<Checkbox />}
//                 label="Select All"
//               />
//               {outletTypes.map((type) => (
//                 <FormControlLabel
//                   key={type}
//                   control={<Checkbox />}
//                   label={type}
//                   sx={{ display: "block" }}
//                 />
//               ))}
//             </Box>
//           )}

//           {selectedTab === 2 && (
//             <Box sx={{ display: "flex", gap: 4 }}>
//               <Box sx={{ width: "200px" }}>
//                 {(Object.keys(lastLoginFilters) as LastLoginKeys[]).map((key) => (
//                   <Box
//                     key={key}
//                     sx={{ display: "flex", alignItems: "center" }}
//                   >
//                     <Checkbox
//                       checked={lastLoginFilters[key]} // ⭐ fixed typing
//                       onChange={() => handleLastLoginClick(key)}
//                     />
//                     <Typography
//                       sx={{
//                         fontSize: "16px",
//                         cursor: "pointer",
//                         p: 1,
//                         background: lastLoginFilters[key]
//                           ? "#EEF4FF"
//                           : "transparent",
//                       }}
//                       onClick={() => handleLastLoginClick(key)}
//                     >
//                       {key}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>

//               {/* Datepicker */}
//               <Box>
//                 <DatePicker
//                   selectsRange
//                   startDate={dateRange[0] ?? undefined}
//                   endDate={dateRange[1] ?? undefined}
//                   onChange={(range: [Date | null, Date | null]) =>
//                     setDateRange(range)
//                   }
//                   inline
//                 />
//               </Box>
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* Footer buttons */}
//       <Box
//         sx={{
//           marginTop: "1rem",
//           width: "100%",
//           justifyContent: "end",
//           display: "flex",
//           borderTop: "1px solid #ddd",
//           pt: 1,
//         }}
//       >
//         <Button sx={{ border: "1px solid #E7E8E9", color: "#000", mr: 1 }}>
//           Clear All
//         </Button>
//         <Button sx={{ border: "1px solid #C8172F", color: "#C8172F" }}>
//           Apply
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default BulkUploadFilter;



"use client";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Tabs,
  Tab,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getalllocations, getalloutlettype } from "../../../pages/assign-task/api";
import arrowLeft from "../../../assests/images/arrow-left.svg";
import arrowRight from "../../../assests/images/arrow-right.png";
import doubleArrowLeft from "../../../assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../assests/images/double-arrow-right.svg";

// ⭐ Define last login keys
type LastLoginKeys =
  | "Today"
  | "Last2Days"
  | "Last3Days"
  | "Last1Week"
  | "MoreThan15Days";
const lastLoginLabels: Record<LastLoginKeys, string> = {
  Today: "Today",
  Last2Days: "Last 2 Days",
  Last3Days: "Last 3 Days",
  Last1Week: "Last 1 Week",
  MoreThan15Days: "More Than 15 Days",
};
const tabsConfig = [
  { key: "locations", label: "Location" },
  { key: "outlettype", label: "Outlet Type" },
  { key: "lastlogin", label: "Last Login" },
];
interface BulkUploadFilterProps {
  appliedFilters: any;
  onApply: (filters: any) => void;
  onClearAll?: () => void; // ⭐ add clear all callback
}

function BulkUploadFilter({ onApply, appliedFilters, onClearAll }: BulkUploadFilterProps) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [localFilters, setLocalFilters] = useState<any>(appliedFilters);
  const handleClearAll = () => {
    const resetFilters = {
      locations: [],
      outlet_type: [],
      lastLogin: "",
      startDate: "",
      endDate: "",
      search: "",
    };
    setLocalFilters(resetFilters);
    if (onClearAll) onClearAll(); // trigger parent immediately
  };
  // 🔹 API driven data
  const [locations, setLocations] = useState<string[]>([]);
  const [outletTypes, setOutletTypes] = useState<string[]>([]);

  // 🔹 Selected checkboxes
  const [selectedLocations, setSelectedLocations] = useState<string[]>(appliedFilters?.locations || []);
  const [selectedOutletTypes, setSelectedOutletTypes] = useState<string[]>(appliedFilters?.outlet_type || []);

  // 🔹 Last login filters state
  const [lastLoginFilters, setLastLoginFilters] = useState<
    Record<LastLoginKeys, boolean>
  >({
    Today: false,
    Last2Days: false,
    Last3Days: false,
    Last1Week: false,
    MoreThan15Days: false,
  });

  useEffect(() => {
    if (appliedFilters?.lastLogin) {
      setLastLoginFilters({
        Today: appliedFilters.lastLogin === "Today",
        Last2Days: appliedFilters.lastLogin === "Last2Days",
        Last3Days: appliedFilters.lastLogin === "Last3Days",
        Last1Week: appliedFilters.lastLogin === "Last1Week",
        MoreThan15Days: appliedFilters.lastLogin === "MoreThan15Days",
      })
    } else {
      setLastLoginFilters({
        Today: false,
        Last2Days: false,
        Last3Days: false,
        Last1Week: false,
        MoreThan15Days: false,
      });
    }

  }, [appliedFilters?.lastLogin])
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    appliedFilters?.startDate ? new Date(appliedFilters.startDate) : null,
    appliedFilters?.endDate ? new Date(appliedFilters.endDate) : null,
  ]);

  // 🔹 Fetch API data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [locRes, outletRes] = await Promise.all([
          getalllocations(),
          getalloutlettype(),
        ]);

        setLocations(locRes?.data?.data || []);
        setOutletTypes(outletRes?.data?.data || []);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchData();
  }, []);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  // 🔹 Handle Select All logic
  const handleSelectAll = (type: "locations" | "outlettype") => {
    if (type === "locations") {
      if (selectedLocations.length === locations.length) {
        setSelectedLocations([]);
      } else {
        setSelectedLocations(locations);
      }
    } else {
      if (selectedOutletTypes.length === outletTypes.length) {
        setSelectedOutletTypes([]);
      } else {
        setSelectedOutletTypes(outletTypes);
      }
    }
  };

  // 🔹 Handle single checkbox
  const handleCheckboxChange = (
    type: "locations" | "outlettype",
    value: string
  ) => {
    if (type === "locations") {
      setSelectedLocations((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value]
      );
    } else {
      setSelectedOutletTypes((prev) =>
        prev.includes(value)
          ? prev.filter((item) => item !== value)
          : [...prev, value]
      );
    }
  };

  // 🔹 Handle last login checkboxes
  const handleLastLoginClick = (key: LastLoginKeys) => {
    setLastLoginFilters((prev) => {
      const updated: Record<LastLoginKeys, boolean> = {
        Today: false,
        Last2Days: false,
        Last3Days: false,
        Last1Week: false,
        MoreThan15Days: false,
      };
      updated[key] = !prev[key];

      const today = new Date();
      let newRange: [Date | null, Date | null] = [null, null];

      switch (key) {
        case "Today":
          newRange = [today, today];
          break;
        case "Last2Days":
          newRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2),
            today,
          ];
          break;
        case "Last3Days":
          newRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate() - 3),
            today,
          ];
          break;
        case "Last1Week":
          newRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7),
            today,
          ];
          break;
        case "MoreThan15Days":
          newRange = [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15),
            today,
          ]
          break;
      }

      setDateRange(newRange);
      return updated;
    });
  };

  const handleApply = () => {
    const selectedLastLogin =
      (Object.keys(lastLoginFilters) as LastLoginKeys[]).find(
        (key) => lastLoginFilters[key]
      ) || "";

    onApply({
      lastLogin: selectedLastLogin,
      locations: selectedLocations,
      outlet_type: selectedOutletTypes,
      startDate: dateRange[0],
      endDate: dateRange[1],
    });
  };

  return (
    <Box
      sx={{
        position: "absolute",
        width: selectedTab === 2 ? "700px" : "400px",
        right: "3%",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        zIndex: 9999,
      }}
    >
      <Box sx={{ width: "100%", display: "flex" }}>
        {/* Tabs */}
        <Box sx={{ width: selectedTab === 2 ? "200px" : "150px", borderRight: "1px solid #ddd" }}>
          <Tabs
            orientation="vertical"
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': {
                alignItems: 'flex-start', // aligns icon/label to left
                justifyContent: 'flex-start', // ensures text starts at left
                textAlign: 'left',
                pl: 2,
              },
            }}
          >
            {tabsConfig.map((tab) => (
              <Tab
                key={tab.key}
                label={tab.label}
                sx={{ textAlign: "left", pl: 2 }}
              />
            ))}
          </Tabs>
        </Box>

        {/* Filters */}
        <Box sx={{ paddingLeft: "20px", flexGrow: 1, display: "flex" }}>
          {/* Locations */}
          {selectedTab === 0 && (
            <Box sx={{ width: "200px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedLocations.length === locations.length}
                    onChange={() => handleSelectAll("locations")}
                  />
                }
                label="Select All"
              />
              {locations.map((loc) => (
                <FormControlLabel
                  key={loc}
                  control={
                    <Checkbox
                      checked={selectedLocations.includes(loc)}
                      onChange={() => handleCheckboxChange("locations", loc)}
                    />
                  }
                  label={loc}
                  sx={{ display: "block" }}
                />
              ))}
            </Box>
          )}

          {/* Outlet Types */}
          {selectedTab === 1 && (
            <Box sx={{ width: "200px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOutletTypes.length === outletTypes.length}
                    onChange={() => handleSelectAll("outlettype")}
                  />
                }
                label="Select All"
              />
              {outletTypes.map((type) => (
                <FormControlLabel
                  key={type}
                  control={
                    <Checkbox
                      checked={selectedOutletTypes.includes(type)}
                      onChange={() => handleCheckboxChange("outlettype", type)}
                    />
                  }
                  label={type}
                  sx={{ display: "block" }}
                />
              ))}
            </Box>
          )}

          {/* Last Login */}
          {selectedTab === 2 && (
            <Box sx={{ display: "flex", gap: 4 }}>
              <Box sx={{ width: "200px" }}>
                {(Object.keys(lastLoginFilters) as LastLoginKeys[]).map((key) => (
                  <Box
                    key={key}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Checkbox
                      checked={lastLoginFilters[key]}
                      onChange={() => handleLastLoginClick(key)}
                    />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        cursor: "pointer",
                        p: 1,
                        background: lastLoginFilters[key]
                          ? "#EEF4FF"
                          : "transparent",
                      }}
                      onClick={() => handleLastLoginClick(key)}                     
                    >
                      {lastLoginLabels[key]} 
                      {/* {key} */}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Datepicker */}
              <Box>
                <DatePicker
                  selectsRange
                  startDate={dateRange[0] ?? undefined}
                  endDate={dateRange[1] ?? undefined}
                  onChange={(range: [Date | null, Date | null]) =>
                    setDateRange(range)
                  }
                  inline
                  renderCustomHeader={({
                    date,
                    decreaseMonth,
                    increaseMonth,
                    decreaseYear,
                    increaseYear,
                  }) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <button onClick={decreaseYear}>
                        <img src={doubleArrowLeft} alt="arrowleft" />
                      </button>

                      {/* Year Arrow */}
                      <button onClick={decreaseMonth}>
                        <img src={arrowLeft} alt="arrowleft" />
                      </button>
                      {/* Month Arrow */}
                      <span style={{ margin: "0 10px" }}>
                        {date.toLocaleString("default", {
                          year: "numeric",
                          month: "long",
                        })}
                      </span>
                      {/* Current Month and Year */}
                      <button onClick={increaseMonth}>
                        <img src={arrowRight} alt="arrow left" />
                      </button>
                      {/* Month Arrow */}
                      <button onClick={increaseYear}>
                        <img src={doubleArrowRight} alt="double arrow" />
                      </button>
                      {/* Year Arrow */}
                    </div>
                  )}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* Footer buttons */}
      <Box
        sx={{
          marginTop: "1rem",
          width: "100%",
          justifyContent: "end",
          display: "flex",
          borderTop: "1px solid #ddd",
          pt: 1,
        }}
      >
        <Button
          sx={{ border: "1px solid #E7E8E9", color: "#000", mr: 1 }}
          onClick={() => {
            console.log('clear all clicked.....')
            setSelectedLocations([]);
            setSelectedOutletTypes([]);
            setLastLoginFilters({
              Today: false,
              Last2Days: false,
              Last3Days: false,
              Last1Week: false,
              MoreThan15Days: false,
            });
            setDateRange([null, null])
            if (onClearAll) onClearAll();
          }}
        >
          Clear All
        </Button>
        <Button
          sx={{ border: "1px solid #C8172F", color: "#C8172F" }}
          onClick={handleApply}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
}

export default BulkUploadFilter;

